import { LiveEditorStepKey } from "@/features/LiveFormEditor/Steps/LiveEditorStep.enum";

export const getIsDonateMode = ({
  allowTeamCreation,
  allowFundraiserCreation,
  allowJoinTeam,
  isPreview,
  liveFormEditorStep,
  hasFundraisers,
  donateQuery,
}: {
  allowTeamCreation: boolean;
  allowFundraiserCreation: boolean;
  allowJoinTeam: boolean;
  isPreview: boolean;
  liveFormEditorStep: LiveEditorStepKey | undefined;
  hasFundraisers: boolean;
  donateQuery: boolean;
}) => {
  if (
    isPreview &&
    (liveFormEditorStep === "suggested-donation-amounts" || liveFormEditorStep === "smart-anchor-amount")
  ) {
    return true;
  }

  if (donateQuery) {
    return true;
  }

  return !hasFundraisers && !allowTeamCreation && !allowFundraiserCreation && !allowJoinTeam;
};
